import { Button, Card, Tabs } from 'antd';
import { EnumTypeReports } from '../../../Enums/TypeReports.enums';
import { useNavigate } from 'react-router-dom';
import { getAll as loadWorkers } from '../../../services/workers.service';
import List from './List';
import Details from './Details';
import Charts from './Charts';
import { useQuery } from '@tanstack/react-query';
import { PropsWithChildren } from 'react';

export default function Reports({
	tab,
	subTab = '',
	id,
	tabBarStyle = {},
	children = null,
}: PropsWithChildren<{
	tab: keyof typeof EnumTypeReports,
	subTab?: string,
	id?: string,
	tabBarStyle?: React.CSSProperties
}>) {
	const navigate = useNavigate();

	const { data: workers = [] } = useQuery(
		['loadWorkers', tab],
		() => {
			const params: any = {
				status: 'active',
				with_relationship: '0',
				type: tab
			};
			return loadWorkers(params);
		},
		{ refetchOnWindowFocus: false }
	);
	
	const workerFilter = `filter_${tab == 'staff' ? tab : tab.substring(0, tab.length - 1)}_id`;
	
	let label = EnumTypeReports[tab];
	
	return (<>
		{children}
		{id ? (
			<Details type={tab} id={id} label={label} />
		) : (
			tab === 'operators' ? (
				<Tabs
					tabBarStyle={tabBarStyle}
					size="large"
					defaultActiveKey={subTab || 'table'}
					destroyOnHidden={true}
					items={[
						{
							key: 'table',
							label: 'Tabela',
							children: (
								<List
									type={tab}
									label={label}
									workerFilter={workerFilter}
									workers={workers}
								/>
							)
						},
						{
							key: 'graphics',
							label: 'Gráficos',
							children: (
								<Charts
									type={tab}
									label={label}
									workerFilter={workerFilter}
									workers={workers}
								/>
							)
						}
					]}
					onChange={(activeKey: string) =>
						navigate(`/control/reports/${tab}/${activeKey}`)
					}
				/>
			) : (
				<List
					type={tab}
					label={label}
					workerFilter={workerFilter}
					workers={workers}
				/>
			)
		)}
	</>);
}